import { TActions } from '../../../AppModulesWrapper';

import {
  UPDATE_DEPOSIT_ACCOUNT_PAYMENT,
  UPDATE_DEPOSIT_ACCOUNT_PAYMENT_STATUS,
  UPDATE_DEPOSIT_ACCOUNT_RECOMMENDED_PACKAGE_PAYMENT_STATUS,
} from '../../actions/depositAccount';
import { RESET_STATE } from '../../actions/resetState';
import { IDepositAccountState } from '../../types/reducers/depositAccount';

export const DEFAULT_STATE: IDepositAccountState = {
  recommendedPackagePaymentStatus: null,
  paymentStatus: null,
  paymentId: null,
  provider: null,
};

export function depositAccount(state: IDepositAccountState = DEFAULT_STATE, action: TActions) {
  switch (action.type) {
    case UPDATE_DEPOSIT_ACCOUNT_PAYMENT:
      return {
        ...state,
        ...action.payload,
        paymentStatus: null,
      };

    case UPDATE_DEPOSIT_ACCOUNT_PAYMENT_STATUS:
      return {
        ...state,
        paymentStatus: action.payload,
      };

    case UPDATE_DEPOSIT_ACCOUNT_RECOMMENDED_PACKAGE_PAYMENT_STATUS:
      return {
        ...state,
        recommendedPackagePaymentStatus: action.payload,
      };

    case RESET_STATE:
      return {
        ...DEFAULT_STATE,
      };

    default:
      return state;
  }
}
